import React from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import { Textarea } from '../../../lib/ui/textarea'

const FindingPurposePageTwo = () => {
  const { formattedExerciseName, exerciseIndex, getResponse, handleChange } =
    useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageTwoTranslations = t('pages.1')
  return (
    <div>
      <PageMessage />
      <p className="!font-bold">{pageTwoTranslations.calling}</p>
      <Textarea
        className="mb-2 min-h-[125px] w-full rounded-[20px]"
        onChange={(e) => handleChange(exerciseIndex, 'calling', e)}
        value={getResponse(exerciseIndex, 'calling') || ''}
      />
      <p className="!font-bold">{pageTwoTranslations.love_to_do}</p>
      <Textarea
        className="min-h-[125px] w-full rounded-[20px]"
        onChange={(e) => handleChange(exerciseIndex, 'love_to_do', e)}
        value={getResponse(exerciseIndex, 'love_to_do') || ''}
      />
    </div>
  )
}

export default FindingPurposePageTwo

const PageMessage = () => {
  const { formattedExerciseName, trackContent } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageTwoTranslations = t('pages.1')
  const selectedPhrases = trackContent[0]?.selected_phrases || []
  const pageOneDataEmpty = selectedPhrases.length === 0
  if (pageOneDataEmpty) return <ReturnMessage />
  return (
    <>
      <p className="!font-bold">{pageTwoTranslations.find_inspiration}</p>
      <ul className="list-disc pl-5">
        {selectedPhrases.map((phrase, index) => (
          <li key={index} className="mb-2">
            {phrase}
          </li>
        ))}
      </ul>
      <p>{pageTwoTranslations.come_together}</p>
    </>
  )
}

const ReturnMessage = () => {
  const { formattedExerciseName, handleBackClick } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageTwoTranslations = t('pages.1')
  const returnMessage = pageTwoTranslations.return_to_previous
  return (
    <div
      onClick={handleBackClick}
      className="mb-8 flex cursor-pointer items-center space-x-2 rounded-lg bg-white p-8 shadow-lg"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6 text-primary hover:text-primary-darker-75"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
        />
      </svg>
      <span className="font-roboto-light text-sm text-primary underline hover:text-primary-darker-75">
        {returnMessage}
      </span>
    </div>
  )
}
